import { render, staticRenderFns } from "./Ejercicio.vue?vue&type=template&id=12529e18&scoped=true"
import script from "./Ejercicio.vue?vue&type=script&lang=js"
export * from "./Ejercicio.vue?vue&type=script&lang=js"
import style0 from "./Ejercicio.vue?vue&type=style&index=0&id=12529e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12529e18",
  null
  
)

export default component.exports